// extracted by mini-css-extract-plugin
export default {"pbutton":"Header_pbutton__-4RY+","sbutton":"Header_sbutton__Eyx3e"};